import { getBackendUrl } from "../config";

/**
 * Builds a browser-loadable URL for contact.profilePicUrl.
 * DB may store a WAHA CDN URL, a /public/ path, or a filename under backend/public/.
 */
export function resolveContactProfilePicUrl(src) {
  if (!src || typeof src !== "string") return "";
  const trimmed = src.trim();
  if (!trimmed) return "";

  if (
    trimmed.startsWith("http://") ||
    trimmed.startsWith("https://") ||
    trimmed.startsWith("//")
  ) {
    return trimmed;
  }

  if (trimmed.startsWith("/public/")) {
    const base = getBackendUrl().replace(/\/$/, "");
    return `${base}${trimmed}`;
  }

  if (trimmed.startsWith("/")) {
    const base = getBackendUrl().replace(/\/$/, "");
    return `${base}${trimmed}`;
  }

  const base = getBackendUrl().replace(/\/$/, "");
  return `${base}/public/${trimmed.replace(/^\//, "")}`;
}
